// extracted by mini-css-extract-plugin
export var body = "scavengerHuntBlock-module--body--3400f";
export var header = "scavengerHuntBlock-module--header--c93f1";
export var icon = "scavengerHuntBlock-module--icon--b7cdd";
export var inner = "scavengerHuntBlock-module--inner--5d7a7";
export var message = "scavengerHuntBlock-module--message--d3c81";
export var title = "scavengerHuntBlock-module--title--32082";
export var value = "scavengerHuntBlock-module--value--9ef6a";
export var value_intro = "scavengerHuntBlock-module--value_intro--75238";
export var wrapper = "scavengerHuntBlock-module--wrapper--040e8";